<template>
  <div class="bill-wrap">
    <div class="bill-tabs">
      <button
        v-for="t in tabs"
        :key="t.status"
        :class="['tab', activeTab === t.status && 'is-active']"
        @click="changeTab(t.status)"
      >{{ t.title }}</button>

      <div class="search">
        <el-input v-model="keyword" placeholder="按订单号、保函号搜索" @keyup.enter.native="search">
          <i slot="prefix" class="el-icon-search"></i>
        </el-input>
        <button class="g-btn g-btn-primary" @click="search">查询</button>
      </div>
    </div>

    <el-table v-if="list.length" :data="list" class="bill-table">
      <el-table-column label="订单编号" prop="tendName" min-width="180"></el-table-column>
      <el-table-column label="项目名称" prop="tendNo" min-width="220"></el-table-column>
      <el-table-column label="保函编号" prop="gatNo" min-width="160"></el-table-column>
      <el-table-column label="保费金额" min-width="120">
        <template #default="{ row }">¥ {{ formatMoney(row.prjEarMoney) }}</template>
      </el-table-column>
      <el-table-column label="申请时间" min-width="160">
        <template #default="{ row }">{{ formatDate(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="160">
        <template #default="{ row }">
          <span :class="['g-tag', invoiceClass(row.invoice)]">
            {{ invoiceText(row.invoice) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template #default="{ row }">
          <a
            v-if="row.invoice === '3' && row.invoiceUrl"
            :href="row.invoiceUrl"
            class="link"
            download
          >
            <i class="el-icon-download"></i> 下载发票
          </a>
        </template>
      </el-table-column>
    </el-table>

    <div v-else class="g-empty">
      <img src="@/assets/noData.png" />
      <p>暂无发票记录</p>
    </div>

    <el-pagination
      v-if="list.length"
      background
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="pageNum"
      @current-change="fetch"
      class="pager"
    />
  </div>
</template>

<script>
import { getOrderList } from '@/lib/api/order'
import { formatDate, formatMoney } from './ucHelpers'

export default {
  name: 'BillList',
  data () {
    return {
      activeTab: '2',
      keyword: '',
      pageNum: 1,
      total: 0,
      list: [],
      tabs: [
        { status: '2', title: '申请中' },
        { status: '3', title: '已开票' }
      ]
    }
  },
  watch: {
    '$route.query.tab' (t) { if (t === 'bill') this.fetch() }
  },
  created () { this.fetch() },
  methods: {
    formatDate, formatMoney,
    fetch () {
      getOrderList({
        orderNo: 'null',
        invoice: this.activeTab,
        name: this.keyword,
        pageSize: 10,
        pageNum: this.pageNum
      }).then((res) => {
        if (res.code === 200) {
          this.list = res.rows || []
          this.total = res.total || 0
        }
      })
    },
    changeTab (s) { this.activeTab = s; this.pageNum = 1; this.fetch() },
    search () { this.pageNum = 1; this.fetch() },
    invoiceText (v) {
      return { '1': '未申请', '2': '申请中', '3': '已开票' }[v] || '-'
    },
    invoiceClass (v) {
      return {
        '1': 'g-tag-info',
        '2': 'g-tag-warning',
        '3': 'g-tag-success'
      }[v] || 'g-tag-info'
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.bill-wrap {
  background: #fff;
  border-radius: @radius-lg;
  padding: 24px;
  box-shadow: @shadow-sm;

  .bill-tabs {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;
    flex-wrap: wrap;

    .tab {
      height: 32px;
      padding: 0 18px;
      border-radius: @radius-full;
      background: @bg-soft;
      border: none;
      color: @text-secondary;
      font-size: 13px;
      cursor: pointer;

      &.is-active { background: @primary; color: #fff; }
    }

    .search {
      margin-left: auto;
      display: flex;
      gap: 10px;
      width: 320px;

      ::v-deep .el-input__inner { border-radius: @radius-full; height: 36px; }
    }
  }

  .bill-table {
    ::v-deep th.el-table__cell {
      background: @bg-soft;
      color: @text-secondary;
      font-weight: 600;
    }
  }

  .link {
    color: @primary;
    font-size: 13px;

    i { margin-right: 4px; }
  }

  .pager { margin-top: 24px; text-align: center; }
}
</style>
